import { Badge } from "@/components/ui/badge"

const TONE: Record<string, "accent" | "signal" | "muted" | "solid" | "neutral"> = {
  active: "accent",
  past_due: "signal",
  incomplete: "muted",
  canceled: "solid",
  unpaid: "solid",
  incomplete_expired: "solid",
}

export function SubscriptionStatusBadge({ status }: { status: string }) {
  return <Badge tone={TONE[status] ?? "neutral"}>{status.replace(/_/g, " ")}</Badge>
}
